/* LL: one shared modal, native modal focus containment plus explicit Tab wrapping. */
(() => {
 if (customElements.get('ll-certificates')) return;
 class LLCertificates extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const on = (node, type, fn) => node.addEventListener(type, fn, {signal:this.abort.signal});
   this.dialog = this.querySelector('dialog');
   this.sync = () => {
    document.querySelectorAll('.ll-cert-mount').forEach(mount => {
     const existing = mount.querySelector('button');
     if (!this.dialog || this.dataset.available !== 'true') { existing?.remove(); return; }
     if (existing) { existing.querySelector('[data-cert-label]').textContent = this.dataset.triggerLabel; return; }
     const template = mount.querySelector('template');
     if (template) { const fragment = template.content.cloneNode(true); fragment.querySelector('[data-cert-label]').textContent = this.dataset.triggerLabel; mount.append(fragment); }
    });
   };
   this.sync(); on(document,'shopify:section:load',this.sync);
   on(document,'click',e => {
    const trigger = e.target.closest('.ll-cert-trigger');
    if (!trigger || !this.dialog || this.dialog.open) return;
    this.opener = trigger; trigger.setAttribute('aria-expanded','true');
    this.resetViewer(); this.dialog.showModal(); this.querySelector('[data-cert-close]').focus();
   });
   if (!this.dialog) return;
   on(this.dialog,'click',e => {
    if (e.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close(); }
    if (e.target.closest('[data-cert-close]')) this.dialog.close();
    const scan=e.target.closest('[data-cert-scan]');
    if(scan){this.scan=scan;this.querySelector('[data-cert-cards]').hidden=true;this.querySelector('[data-cert-viewer]').hidden=false;const img=this.querySelector('[data-cert-large]');img.src=scan.dataset.src;img.alt=scan.dataset.title;this.querySelector('[data-cert-caption]').textContent=scan.dataset.title;this.querySelector('[data-cert-back]').focus();}
    if(e.target.closest('[data-cert-back]')){this.resetViewer();this.scan?.focus();}
    if(e.target.closest('[data-cert-zoom]')){const zoom=this.querySelector('[data-cert-zoom]');const active=this.querySelector('.ll-certs__pan').classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));}
   });
   on(this.dialog,'close',()=>{this.opener?.setAttribute('aria-expanded','false');if(this.opener?.isConnected)this.opener.focus();});
   on(this.dialog,'keydown',e=>{
    if(e.key!=='Tab')return;
    const nodes=[...this.dialog.querySelectorAll('button,a[href],[tabindex="0"]')].filter(n=>!n.disabled&&n.getClientRects().length);
    const first=nodes[0],last=nodes.at(-1);
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
   });
   on(document,'shopify:block:select',e=>{if(this.contains(e.target)&&!this.dialog.open){this.resetViewer();this.dialog.showModal();}});
  }
  resetViewer(){this.querySelector('[data-cert-cards]').hidden=false;this.querySelector('[data-cert-viewer]').hidden=true;this.querySelector('.ll-certs__pan').classList.remove('is-zoomed');this.querySelector('[data-cert-zoom]').setAttribute('aria-pressed','false');}
  disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.abort?.abort();document.querySelectorAll('.ll-cert-mount > button').forEach(n=>n.remove());}
 }
 customElements.define('ll-certificates',LLCertificates);
})();
